// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductDashboardCartControls_root__fAOeo","addToCartButton":"ProductDashboardCartControls_addToCartButton__tA8um"};